import Image from './Image';
import PreviewGroup from './PreviewGroup';
import Base from '../base';

Image.Group = PreviewGroup;

/* istanbul ignore next */
Image.install = function(Vue) {
  Vue.use(Base);
  Vue.component(Image.name, Image);
  Vue.component(PreviewGroup.name, PreviewGroup);
};

export default Image;
